import { EnvironmentProviders } from '@angular/core';

import { provideTagsDataAccess } from '@efficiently/client-data-access-tags';

export const tagsProviders: EnvironmentProviders[] = [provideTagsDataAccess()];
